import { push } from '@lagunovsky/redux-react-router'
import { Card, CardContent, Stack } from '@mui/material'
import HomeAction from 'home/actions/HomeAction'
import React, { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import i18n from 'simple-react-i18n'
import { H_MAT_DASHBOARD } from '../../../account/constants/AccessRulesConstants'
import CampaignAction from '../../../campaign/actions/CampaignAction'
import CampaignCard from '../../../campaign/components/CampaignCard'
import { CardTitle } from '../../../components/card/NewCard'
import SieauAction from '../../../components/sieau/SieauAction'
import EventsAction from '../../../events/actions/EventsAction'
import MonitoredStationCard from '../../../events/components/MonitoredStationCard'
import MaterielAction from '../../../materiel/actions/MaterielAction'
import PiezometryAction from '../../../piezometry/actions/PiezometryAction'
import QualityAction from '../../../quality/actions/QualityAction'
import { componentHasHabilitations } from '../../../utils/HabilitationUtil'
import MonitoredMaterielPortletPanel from './MonitoredMaterielPortletPanel'
import { STATION_TYPE_CONSTANT } from '../../../station/constants/StationConstants'
import { darkBlue } from '../../../utils/constants/ColorTheme'

const renderSection = (title, content) => {
    const hasContent = Array.isArray(content) ? content.length > 0 : !!content
    if (!hasContent) {
        return null
    }
    return (
        <Card>
            <CardTitle title={title} color={darkBlue} />
            <CardContent>
                {content}
            </CardContent>
        </Card>
    )
}

const MaterielDashboardApp = () => {
    const dispatch = useDispatch()

    const monitoredStations = useSelector(state => state.EventsReducer.monitoredStations)
    const monitoredMateriels = useSelector(state => state.MaterielReducer.monitoredMateriels)
    const piezometers = useSelector(state => state.PiezometryReducer.piezometersLight)
    const piezometryCampaigns = useSelector(state => state.PiezometryReducer.piezometryCampaigns)
    const piezometryCampaignsProgress = useSelector(state => state.PiezometryReducer.piezometryCampaignsProgress)
    const qualitometers = useSelector(state => state.QualityReducer.qualitometersLight)
    const accountUser = useSelector(state => state.AccountReducer.accountUser)

    useEffect(() => {
        if (!componentHasHabilitations(H_MAT_DASHBOARD)) {
            dispatch(push('/unauthorized'))
            return
        }
        dispatch(HomeAction.setHelpLink('materiel', ''))
        dispatch(EventsAction.fetchMonitoredStations())
        dispatch(MaterielAction.fetchMonitoredMateriels())
        dispatch(CampaignAction.fetchPiezometryCampaigns())
        dispatch(CampaignAction.fetchPiezometryCampaignsProgress())
        dispatch(SieauAction.forceFetch('title', [{
            title: i18n.materiel,
            href: 'materiel',
        }, {
            title: i18n.dashboard,
            href: 'materiel',
        }]))
        if (!piezometers.length) {
            dispatch(PiezometryAction.fetchAllPiezometers())
        }
        if (!qualitometers.length) {
            dispatch(QualityAction.fetchQualitometersLight())
        }
    }, [])

    const currentCampaigns = piezometryCampaigns.reduce((acc, c) => {
        const { nbStation, nbStationValidated } = piezometryCampaignsProgress.find(cp => cp.id === c.id) || {}
        if (nbStation !== 0 && nbStationValidated < nbStation) {
            return [...acc, c]
        }
        return acc
    }, [])

    const piezometryCampaignCards = currentCampaigns.filter(c => c.statut === 2).map(c => (
        <CampaignCard
            key={piezometryCampaignsProgress.id}
            campaign={c}
            progress={piezometryCampaignsProgress.find(cp => cp.id === c.id)}
            stationType={'piezometry'}
        />
    ))

    const filteredStations = monitoredStations
        .filter(s => s.type === STATION_TYPE_CONSTANT.PIEZOMETRY && piezometers.some(p => p.id === s.id)
            || s.type === STATION_TYPE_CONSTANT.QUALITY && qualitometers.some(q => q.id === s.id)
        )
    const stationTable = filteredStations.length
        ? <MonitoredStationCard stations={filteredStations} onClickEnable={!(accountUser.consultant === '1')} />
        : null

    const filteredMonitoredMateriels = monitoredMateriels.filter(m => piezometers.find(p => p.id === m.idSite)
        || qualitometers.find(p => p.id === m.idSite))
    const materielCards = filteredMonitoredMateriels.length ? <MonitoredMaterielPortletPanel allStationType showTitle={false}/> : null

    return (
        <Stack spacing={2} sx={{ width: '100%' }}>
            {renderSection(i18n.currentPiezometryCampaigns, piezometryCampaignCards)}
            {renderSection(i18n.monitoredStations, stationTable)}
            {renderSection(i18n.monitoredMateriels, materielCards)}
        </Stack>
    )
}

export default MaterielDashboardApp
